import { render, staticRenderFns } from "./InsightNav.vue?vue&type=template&id=ecb6b032&"
import script from "./InsightNav.vue?vue&type=script&lang=js&"
export * from "./InsightNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports